const messages = require('./th-TH/index.json');

export default messages;
